export default __webpack_public_path__ + "static/0238-5de7d48d0fe722317a422a31662220c6.png";